<template>
    
    <div class="page__content" >

        <HeaderBody/>

        <div class="activity" >
                    <div class="activity__container">
                        
                        <div class="activity__sorting">

                            <div class="activity__tags tablet-hide">
                                <router-link class="activity__link " :to="{name: 'borrow'}" id="rStaking11">Borrow crypto</router-link>
                                <router-link class="activity__link active" :to="{name: 'borrow-history'}" id="rStaking12">History & repayments</router-link>
                                
                                
                            </div>

                            <div class="activity__tags tablet-show">
                                <router-link class="activity__link " :to="{name: 'borrow'}" id="rStaking21"  style="padding: 10px 15px 10px 15px;">Borrow crypto</router-link>
                                <router-link class="activity__link active"  :to="{name: 'borrow-history'}" id="rStaking22" style="padding: 10px 15px 10px 15px;">History & repayments</router-link>
                                
                                
                            </div>
                            
                        </div>
                        
                        
                    </div>
                    
        </div>

        <div class="promotions">
                    <div class="promotions__wrapper" >

                        <div class="wallets__wrapper" style="margin-top: -45px; margin-bottom: 0px;">
                            <div class="wallets__row">
                                <div class="wallets__total">
                                <div class="wallets__title b6">Total borrowed</div>
                                <div class="wallets__flex">
                                  <!-- <div class="wallets__number b3">{{totalSol}}</div>
                                  <div class="wallets__currency" style="background-color: #6F2880;">SOL</div> -->
                                  <div class="wallets__number b3" >${{totalBorrowedUsd}}</div>
                                  
                                </div>
                                <!-- <div class="wallets__price b5" > ${{totalUsd}}</div> -->
                              </div>
                                
                            </div>
                            <div class="wallets__inner">
                                <div class="wallets__list">
                                    <div class="wallets__item">
                                        <div class="wallets__icon">
                                            <img src="@/assets/dashAssets/img/circle-purple.svg" alt="">
                                        </div>
                                        <div class="wallets__details">
                                            <div class="wallets__info ">Pending</div>
                                            <div class="wallets__price ">{{pending}}</div>
                                        </div>
                                    </div>
                                    <div class="wallets__item">
                                        <div class="wallets__icon">
                                            <img src="@/assets/dashAssets/img/circle-blue.svg" alt="">
                                        </div>
                                        <div class="wallets__details">
                                            <div class="wallets__info ">completed</div>
                                            
                                            <div class="wallets__price ">{{completed}}</div>
                                        </div>
                                    </div>

                                    <!-- <div class="search__preview mtn">
                                        <img src="@/assets/dashAssets/img/loanFigure.png" alt="">
                                    </div> -->

                                </div>


                            </div>

                            
                            
                        </div>
                        
                        <br>
                        <hr style="opacity: 0.1; margin-top: 30px; margin-bottom: 30px;">
                        <br>

                        
                        <div class="promotions__list">

                            <div class="promotions__item" v-for="borrow in borrowList" :key="borrow.number" >
                                <a class="promotions__preview" style="width: 100%; display:flex; justify-content:center; align-items:center; margin-top: 20px; margin-bottom: 5px;">
                                    <img :src="borrow.loanImage" alt="" style="width: 50px; border-radius: 50%; ">

                                    <img :src="borrow.colImage" alt="" style="width: 50px; border-radius: 50%; ">
                                </a>
                                

                                <div style="width: 100%; display:flex; justify-content:space-around; align-items:center; flex-direction: column;">
                                    <h5 style="color:#ffffff; margin-top: 5px;">{{borrow.loanSymbol}}--{{ borrow.colSymbol }}</h5>
                                    
                                </div>     

                                <div class="promotions__body">

                                    <hr style="opacity: 0.1; margin-top: 10px; margin-bottom: 20px;">
                                    

                                    <div >

                                        <div style="width: 100%; display:flex; justify-content:space-between; align-items:center; padding: 10px">
                                            <p style="font-size: 12px; color:#8f8e8e; ">Loan amount </p>
                                            <p>{{ borrow.loanAmount }} {{ borrow.loanSymbol }}</p>
                                        </div>

                                        <div style="width: 100%; display:flex; justify-content:space-between; align-items:center; padding: 10px">
                                            <p style="font-size: 12px; color:#8f8e8e; ">Collateral amount</p>
                                            <p>{{ borrow.colAmount }} {{ borrow.colSymbol }}</p>
                                        </div>

                                        
    
                                        <div style="width: 100%; display:flex; justify-content:space-between; align-items:center; padding: 10px;">
                                            <p style="font-size: 12px; color:#8f8e8e; ">Interest rate</p>
                                            <p>{{borrow.interest}}%</p>
                                        </div>


                                        <div style="width: 100%; display:flex; justify-content:space-between; align-items:center; padding: 10px;" >
                                            <p style="font-size: 12px; color:#8f8e8e; ">Repayment</p>
                                            <p>{{ borrow.repayment }} {{ borrow.loanSymbol }}</p>
                                        </div>


                                        <div style="width: 100%; display:flex; justify-content:space-between; align-items:center; padding: 10px;" >
                                            <p style="font-size: 12px; color:#8f8e8e; ">Start date</p>
                                            <p>{{ borrow.startDate }}</p>
                                        </div>

                                        <div style="width: 100%; display:flex; justify-content:space-between; align-items:center; padding: 10px;">
                                            <p style="font-size: 12px; color:#8f8e8e; ">End date</p>
                                            <p>{{ borrow.endDate }}</p>
                                        </div>

                                        <div style="width: 100%; display:flex; justify-content:space-between; align-items:center; padding: 10px;">
                                            <p style="font-size: 12px; color:#8f8e8e; ">Term</p>
                                            <p>{{ borrow.term }}</p>
                                        </div>

                                        <div style="width: 100%; display:flex; justify-content:space-between; align-items:center; padding: 10px;">
                                            <p style="font-size: 12px; color:#8f8e8e; ">Status</p>
                                            <div class="promotions__date bg-green-opacity color-orange" v-if="borrow.status=='pending'">{{borrow.status}}</div>
                                            <div class="promotions__date bg-green-opacity color-green" v-if="borrow.status=='completed'">{{borrow.status}}</div>

                                            <div class="promotions__date bg-red-opacity color-red" v-if="borrow.status=='default'">defaulted</div>
                                        </div>
                                    </div>

                                    
                                    <button class="details__btn btn btn_blue btn_wide" style="margin-top: 30px; margin-bottom:10px" v-if="borrow.status=='pending'" @click="repay(borrow)"> Repay loan </button>

                                </div>
                            </div>
                            
                        </div>
                        
                    </div>
        </div>

    </div>


    <div style=" display: flex; justify-content: center; align-items: center; z-index: 9999;  " class="loadingModalBg" ref="loadingModal">

            <div class="popup__container" style="width: 300px; background-color:#1F2128; border-radius: 30px; padding: 20px;">
                        
                <div class="popup__box">

                    <div class="popup__fieldset" >
                        
                        <div class="popup__row" style="width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                            
                            <img src="@/assets/dashAssets/img/loading.gif" alt="">

                            <p style="text-align: center; color: #ffffff;">{{loadingText}}</p>
                            
                        </div>

                        
                        
                        
                    </div>
                    

                    

                    
                </div>
                
            </div>

        </div>

        <div style=" display: flex; justify-content: center; align-items: center; z-index: 9999;  " class="loadingModalBg" ref="successModal">

        <div class="popup__container" style="width: 300px; background-color:#1F2128; border-radius: 30px; padding: 20px;">
                    
            <div class="popup__box">

                <div class="popup__fieldset" >
                    
                    <div class="popup__row" style="width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                        
                        <img src="@/assets/dashAssets/img/done.png" alt="" style="width: 100px; margin: 10px;">

                        <p style="text-align: center; margin-bottom: 40px; color: #ffffff;">{{successText}}</p>

                        <button class="operations__btn btn btn_blue" @click="closeS">Okay</button>
                        
                    </div>

                    
                    
                    
                    
                </div>
                

                

                
            </div>
            
        </div>

        </div>

        <div style=" display: flex; justify-content: center; align-items: center; z-index: 9999;  " class="loadingModalBg" ref="errorModal">

        <div class="popup__container" style="width: 300px; background-color:#1F2128; border-radius: 30px; padding: 20px;">
                    
            <div class="popup__box">

                <div class="popup__fieldset" >
                    
                    <div class="popup__row" style="width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                        
                        <img src="@/assets/dashAssets/img/error.png" alt="" style="width: 100px; margin: 10px;">

                        <p style="text-align: center; margin-bottom: 40px; color: #ffffff;">{{errorText}}</p>

                        <button class="operations__btn btn btn_blue" @click="closeE">Okay</button>
                        
                    </div>

                    
                    
                    
                </div>
                

                

                
            </div>
            
        </div>

        </div>

</template>


<script>

    import { doc, addDoc, collection, query, where, getDocs, getDoc, serverTimestamp, updateDoc, increment, orderBy } from "firebase/firestore"; 
    import { db } from '@/firebase';
    import axios from 'axios';
    import HeaderBody from '@/components/dashboard/HeaderBody.vue';

    export default {

        components:{
            HeaderBody,
        },

        data(){
            return{

                loadingText:"",
                successText: "",
                errorText: "",

                totalBorrowedUsd: "0.00",
                pending: 0,
                completed: 0,

                borrowList: []

            }
        },

        mounted(){
            this.niceSelect();

            document.getElementById("rWallet").classList.remove("active");
            document.getElementById("rSwap").classList.remove("active");
            document.getElementById("rStaking").classList.remove("active");
            document.getElementById("rTrans").classList.remove("active");
            document.getElementById("rCard").classList.remove("active");

            document.getElementById("rBorrow").classList.add("active");

            this.getLoanTrans();
        },

        methods:{

            round(num, decimals){
                return +(Math.round(num + "e" + decimals) + "e-" + decimals);
            },

            closeS(){
                this.$refs.successModal.classList.remove("bg-active");
                this.$router.go();
            },

            closeE(){
                this.$refs.errorModal.classList.remove("bg-active");
            },

            niceSelect(){
                $('.select').niceSelect();
            },

            copy(){
                navigator.clipboard.writeText(this.xrpSpotAddress);
                this.$refs.successModal2.classList.add("bg-active");
                this.successText2 = "The address has been copied to your clipboard";
            },

            async getLoanTrans(){
                //start loading
                this.loadingText= "Loading...";
                this.$refs.loadingModal.classList.add("bg-active"); 

                const q = query(collection(db, "UserLoans"), where("userId", "==", sessionStorage.getItem("id")), orderBy("startDate", "desc")); 
                const querySnapshot = await getDocs(q);

                let i = -1;
                let a2, a3;
                let activeTemp = 0;
                let completedTemp = 0;
                

                let todaySecs = new Date().getTime()/1000;
                let mReward = 0;

                querySnapshot.forEach((doc) => {
                    i++;

                    a2 = String(new Date(Number(doc.data().startDate.seconds) * 1000));
                    a3 = String(new Date(Number(doc.data().endDate) * 1000));
                    
                    //count active
                    if(doc.data().status == "pending"){
                        activeTemp++;
                    }
                    else{
                        completedTemp++;
                    }

                    this.borrowList[i] = {
                        number: i,
                        id: doc.id,
                        
                        endDateSecs: Number(doc.data().endDate),
                        endDate: a3.slice(0, -36),
                        startDate: a2.slice(0, -36),
                        startDateSecs: Number(doc.data().startDate.seconds),
                        status: doc.data().status,
                        
                        loanCoin: doc.data().loanCoin,
                        loanSymbol: doc.data().loanSymbol,
                        loanAmount: doc.data().loanAmount,
                        loanImage: doc.data().loanImage,
                        loanWalletId: doc.data().loanWalletId,

                        colCoin: doc.data().colCoin,
                        colSymbol: doc.data().colSymbol,
                        colAmount: doc.data().colAmount,
                        colImage: doc.data().colImage,
                        colWalletId: doc.data().colWalletId,

                        userId: doc.data().userId,
                        term : "1 year",
                        interest: doc.data().interest,
                        repayment: doc.data().repayment,
                        status: doc.data().status
                    }
                    
                })

                this.pending = activeTemp;
                this.completed = completedTemp;

                if(this.borrowList.length > 0){
                    this.getTotal();
                }

                this.$refs.loadingModal.classList.remove("bg-active"); 
            },

            async getTotal(){

                let temp;
                let temp2 = 0;
                let totalUsd;

                for(let i=0; i< this.borrowList.length; i++){

                    if(this.borrowList[i].status == 'pending'){

                        const response = await axios.get("https://api.omcdex.com/v1/coin-price", {
                            params: {
                                ids: 825
                            }
                        })
                        let price = Number(Object.values(response.data.data)[0].price);
                        let lockedAmount = this.borrowList[i].loanAmount;
                        temp = price * lockedAmount;
                        temp2 += temp; 
                            
                        totalUsd = this.round(temp2, 2);
                        this.totalBorrowedUsd = Number(totalUsd).toLocaleString("en-US");
                    }

                }

                

            },

            async repay(borrow){
                
                let balance;

                this.loadingText= "Repaying loan...";
                this.$refs.loadingModal.classList.add("bg-active"); 
                
                const loanRef = doc(db, "UserWallets", borrow.loanWalletId);
                
                //check usdt balance
                const loanSnap = await getDoc(loanRef);

                if (loanSnap.exists()) {
                    balance = loanSnap.data().balance;
                }

                if(balance < Number(borrow.repayment)){
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    this.errorText = "Insufficient USDT balance";
                    return;
                }

                //take usdt
                let num = Number(borrow.repayment)
                
                await updateDoc(loanRef, {
                    balance: increment(-num)
                });

                //return collateral
                let num2 = Number(borrow.colAmount);
                const colRef = doc(db, "UserWallets", borrow.colWalletId);
                await updateDoc(colRef, {
                    balance: increment(num2)
                });

                //update status
                const statusRef = doc(db, "UserLoans", borrow.id);
                await updateDoc(statusRef, {
                    status: "completed"
                });

                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.successModal.classList.add("bg-active");
                this.successText = "Loan repayment was successful. Your collateral has been returned to your spot wallet";

            }

        }
        
    }

</script>